import { render, staticRenderFns } from "./SubMenuMainSm.vue?vue&type=template&id=60715791&scoped=true&"
import script from "./SubMenuMainSm.vue?vue&type=script&lang=js&"
export * from "./SubMenuMainSm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60715791",
  null
  
)

export default component.exports